import {BaseTerms} from "../../infrastructure/models/base-terms";

export class GamesSliderWidgetTerms extends BaseTerms {}
